import { render, staticRenderFns } from "./NbCard.vue?vue&type=template&id=1cd61891&scoped=true&"
import script from "./NbCard.vue?vue&type=script&lang=js&"
export * from "./NbCard.vue?vue&type=script&lang=js&"
import style0 from "./NbCard.vue?vue&type=style&index=0&id=1cd61891&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd61891",
  null
  
)

export default component.exports